import React from "react";
import image_2 from "../../images/agriculture/Picture41.webp";

const Address = () => {
  return (
    <section className="bg-chinese-black">
      <div className="ms-13 me-13 pt-5 pb-7 text-center">
        <div className="">
          <div className="d-md-flex align-items-center justify-content-center bg-white agriculture-address-container">
            <div className="">
              <img src={image_2} className="img-fluid" alt="" />
            </div>
            <div className="">
              <div className="fs-14 text-start">
                <p>Head Office: Giza – 6th of October City</p>
                <p>Export Office: </p>
                <p>
                  18/1/4 Farrag Mall, Central Axis, 2nd District 6th of October
                  City, Giza, Egypt.
                </p>
                <p>Tel : (+20) 2 38367340/9</p>
                <p>info@segamdates.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Address;
